import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"
import { cn } from "@/lib/utils"
import { statusToneClass as tone, toneForStatus } from "./statusTones"

const badgeVariants = cva(
  "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        // Base. `default` is ink, not clay: clay is reserved for actions.
        default:     tone.ink,
        secondary:   "border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80",
        destructive: tone.danger,
        outline:     "text-foreground",
        // Semantic status: one palette for every badge (statusTones.ts)
        success:   tone.success,
        warning:   tone.warning,
        error:     tone.danger,
        info:      tone.info,
        // Booking-specific
        confirmed:  tone[toneForStatus('confirmed')],
        pending:    tone[toneForStatus('pending')],
        cancelled:  tone[toneForStatus('cancelled')],
        completed:  tone[toneForStatus('completed')],
        // Helper profile status
        approved:   tone[toneForStatus('approved')],
        rejected:   tone[toneForStatus('rejected')],
        suspended:  tone[toneForStatus('suspended')],
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props} />
  )
}

export { Badge, badgeVariants }
